export default __webpack_public_path__ + "static/media/cp_geo_za.0386a651.svg";